import {TemplateList} from "~/libs/constants/TemplateList"

/**
 * Per-template limit of RENDERED embeds on article detail.
 *
 * - number → at most N rendered embeds are kept, in document order; the rest are
 *   filtered out of the art-object list before render (SSR included)
 * - 0 → valid, renders no embeds at all
 * - null → no limit, feature disabled for that template (no behaviour change)
 *
 * "Rendered" means the embed actually produces markup today — see
 * `useArticleEmbeds().isRenderableEmbed()`. Art objects that render nothing
 * (paymentBox tip jars, providers missing from CncSimpleArtobjectConfig) do NOT
 * consume a slot and are never removed.
 *
 * HeyFomo = 1 (lowered from 2 on 2026-08-13, PO decision) after the Seznam News Feed
 * rejection of seznam.heyfomo.cz (relayed as
 * "max 1-2 embeds per article"). WARNING: this limit is NOT backed by any published
 * Seznam rule — the partner terms (incl. the version effective 2026-05-01) contain no
 * embed cap. See FEAT-009 "Problem" and "Open questions" before changing or removing it.
 *
 * This value is the intended escape hatch: adjust the number here (rebuild + redeploy
 * required, template is build-time) instead of touching component code.
 */
export const ArticleEmbedLimitConfig: Record<TemplateList, number | null> = {
  [TemplateList.HEYFOMO]: 1,
  [TemplateList.POGGERS]: null,
  [TemplateList.MATERIDOUSKA]: null,
}
